import { Select, Input } from "antd"
import MobileLayout from "../../layout"
import './index.scss'
import { useEffect, useRef, useState } from "react"
import { listResumeUser, getJobDescription, generateQuestions, updateJobDescription } from "@/http/api"
import { useNavigate } from "react-router-dom"
import './index2.scss'
import { icon3, processDesc } from "./const"
import { useDispatch } from "@/components/resume/redux/hooks"
import withStore from "@/components/resume/hoc/withStore"
import interviewSlice from "@/components/resume/redux/services/interviewSlice"
import useSelector from "@/components/resume/redux/hooks/useSelector"
import { debounce } from "lodash"
import { processInterviewData } from "@/pages/ResumeDetail/component/Interview"
import { message } from 'antd'


const InterView = withStore(() => {

    const [optionList, setOptionList] = useState([])
    const [selectId, setSelectId] = useState()
    const [inputValue, setInputValue] = useState('')
    const selectJdId = useSelector((state) => state.interview.selectJdId)
    const dispatch = useDispatch()
    const [dataList, setDataList] = useState([])
    const [pageLoading, setPageLoading] = useState(false)

    const lockBtnRef= useRef(false)

    const navigate = useNavigate()

    useEffect(() => {
        setPageLoading(true)
        fetchResumeList()
    }, [])

    const fetchResumeList = async () => {
        const res = await listResumeUser({
            query: {
                page: 1,
                pageSize: 10
            }
        });
        const temp = res.dataList.map((item, index) => {
            return {
                label: item.name,
                value: item.id
            }
        } )
        setOptionList(temp)
        if(temp.length){
            getDataList(temp[0]?.value)
            setSelectId(temp[0]?.value)
        }
        setPageLoading(false)
    }

    const getDataList = (id) => {
        getJobDescription({
            query: {
                resumeId: id || resumeId,
            }
        }).then(data => {
            if (data) {
                let newDataList = data.map(item => {
                    const { jobTitle, content } = processDesc(item.description)
                    return {
                        id: item.id,
                        title: jobTitle,
                        content,
                        description: item.description
                    }
                })
                if (newDataList && newDataList.length > 0) {
                    const jdId = newDataList[newDataList.length - 1].id
                    dispatch(interviewSlice.actions.setJdId(jdId))
                    setDataList(newDataList)
                }
            }
        }).catch(err => {
            console.log('err', err)
        })
    }

    const handleUpdateContent = (e) => {
        const { jobTitle, content } = processDesc(e.target.value)
        const newDataList = dataList.map(item => {
            if (item.id === selectJdId) {
                return {
                    ...item,
                    title: jobTitle,
                    content,
                    description: e.target.value
                }
            } else {
                return item
            }
        })
        updateJobDescription({
            body: {
                content,
                description: e.target.value,
                id: selectJdId,
                resumeUserId: selectId,
                title: jobTitle,
            }
        })
        setDataList(newDataList)
    }

    const handleClickButton = async () => {
        if(lockBtnRef.current) return
        lockBtnRef.current = true
        message.loading({
            content: '生成中...',
            duration: 0
        })
        const jdId = parseInt(dataList[0].id) 
        try {
            const res = await generateQuestions({
                query: {
                    resumeId: selectId,
                    userResumeJobDescriptionId: jdId
                }
            })
            if (res) {
                // const jdId = newDataList[newDataList.length - 1]?.id
                const newList = processInterviewData(res)
                dispatch(interviewSlice.actions.setList(newList))
                // dispatch(interviewSlice.actions.setJdId(jdId))
            }
        } catch (error) {
            console.log('err', error)
        } finally {
            message.destroy()
            lockBtnRef.current = false
        }
        navigate(`/mobile/interview/question?id=${selectId}&jdId=${jdId}`)
    }

    const handleChangeSelect = (v) => {
        setSelectId(v)
        getDataList(v)
    }

    return (
            <MobileLayout>
                {
                    pageLoading ? <></> : optionList.length ? <div className="iv-page">
                    <div className="iv-select">
                        <div className="iv-select-title">选择简历</div>
                        {optionList.length > 0 && <Select
                         onChange={(v) => handleChangeSelect(v)}
                         options={optionList} 
                         defaultValue={optionList?.[0]?.value}
                         popupClassName='iv-ant-popup'
                         className="iv-ant-select" />}
                    </div>
                    <div className="iv-description">
                        <div className="iv-select-title">目标岗位描述（可选）</div>
                        <Input.TextArea value={dataList?.[0]?.description || ''} onChange={handleUpdateContent} className="iv-ant-input">
                        </Input.TextArea>
                        {
                            !dataList?.[0]?.description && <div className="tips">
                            <p>职位要求：</p>
                            <p>1、本科及以上学历，计算机软件相关专业，3年以上互联网开发经验</p>
                            <p>2、熟练掌握Java技术，对多线程、数据结构、GC等有深刻认识</p>
                        </div>
                        }
                    </div>
                    <div onClick={handleClickButton} className="iv-button">生成面试问题{icon3}</div>
                </div> : <div className="empty-page">
                    <div className="empty-modal">
                        <div className="content">面试问题基于简历生成，暂无简历，请先新建简历</div>
                        <div onClick={() => navigate(`/mobile/index`)} className="btn">新建简历</div>
                    </div>
                </div>
                }
            </MobileLayout>
    )
})

export default InterView